import { SummaryFeatureRuleMap } from '../types';
import Grow2529FeatureRules from '~app/pages/Pricing/experiments/grow_2529_forms/transformers/summary/featureRules';

const ExperimentFeatureRules: SummaryFeatureRuleMap = {
  ...Grow2529FeatureRules,
};

export default ExperimentFeatureRules;
